import { Image } from '$partials/media';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').TwoImagesLandscape}
 */
const TwoImagesLandscape = ({
    image1,
    image2,
    video1,
    video2,
    caption1,
    caption2
}) => {
    return (
        <div>
            {/* images */}
            <div className='col-12 flex flex-wrap items-end justify-between'>
                <div className='col-12 sm-col-6 mb4 sm-mb0 sm-pr3 md-pr4 self-stretch'>
                    <figure className='height-100'>
                        {video1 ? (
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                className='height-100 width-100 object-cover'
                                src={video1.videoUrl}/>
                        ) : (
                            <Image
                                {...image1}
                                height={950}
                                width={1440}/>
                        )}
                    </figure>
                    {caption1 &&
                        <figcaption className='sm-hide mt3'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption1}}/>
                        </figcaption>
                    }
                </div>
                <div className='col-12 sm-col-6 sm-pl3 md-pl4 self-stretch'>
                    <figure className='height-100'>
                        {video2 ? (
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                className='height-100 width-100 object-cover'
                                src={video2.videoUrl}/>
                        ) : (
                            <Image
                                {...image2}
                                height={950}
                                width={1440}/>
                        )}
                    </figure>
                    {caption2 &&
                        <figcaption className='sm-hide mt3'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption2}}/>
                        </figcaption>
                    }
                </div>
            </div>

            {/* desktop/tablet captions */}
            <div className='hide sm-show'>
                <div className='col-12 flex items-end justify-between'>
                    <div className='col-6 sm-col-6 pr3 md-pr4'>
                        {caption1 &&
                        <figcaption className='pt3'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption1}}/>
                        </figcaption>
                        }
                    </div>
                    <div className='col-4 sm-col-6 sm-pl3 md-pl4'>
                        {caption2 &&
                        <figcaption className='pt3'>
                            <div
                                className='rich-text type-style-7'
                                dangerouslySetInnerHTML={{__html: caption2}}/>
                        </figcaption>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TwoImagesLandscape;
